/** @jsxImportSource @emotion/react */
import { FolderOpen } from 'lucide-react'
import { Box, Typography, useTheme } from '@mui/material'
import { Dialog, DialogContent } from '@app/components/ui/Dialog/Dialog'

import {
  iconBoxStyles,
  dialogTitleStyles,
  dialogContentStyles,
  dialogBoxStyles,
} from './WorkspacesDialog.styles'
import { Outlet, useNavigate } from 'react-router-dom'

const WorkspacesDialog = () => {
  const theme = useTheme()
  const navigate = useNavigate()

  const handleClose = () => {
    navigate('..')
  }

  return (
    <Dialog open onOpenChange={(open) => !open && handleClose()}>
      <DialogContent onClose={handleClose} css={dialogContentStyles(theme)}>
        <Box display="flex" justifyContent="center" alignItems="center" padding="12px" gap="12px">
          <Box css={iconBoxStyles(theme)}>
            <FolderOpen size={20} color={theme.palette.primary.main} />
          </Box>
          <Typography variant="h6" css={dialogTitleStyles}>
            Workspaces
          </Typography>
        </Box>
        <Box role="dialog" css={dialogBoxStyles(theme)}>
          <Box
            sx={{
              backgroundColor: '#FFF',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default WorkspacesDialog
